import { ICellRenderers } from '../../types/grid';
import { IFields } from '../fields';
import { flagRenderer } from './flag';
import { noteRenderer } from './note';
import { positionRenderer } from './position';
import { errorRenderer } from './error';
import { listeningRenderer } from './listening';

import { pngRenderer } from './png';

export const globalRenderers: ICellRenderers = {
  [IFields.position]: positionRenderer,
  [IFields.notes]: noteRenderer,
  [IFields.notesStatus]: noteRenderer,
  [IFields.flag]: flagRenderer,
  [IFields.error]: errorRenderer,
  [IFields.listening]: listeningRenderer,

  [IFields.pngOriginal]: pngRenderer,
  [IFields.png]: pngRenderer,
};
